"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _basis = require("basis");

var _AutoAddress = require("./AutoAddress");

var _ManualAddress = require("./ManualAddress");

var _styled = _interopRequireDefault(require("@emotion/styled"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var TransparentCheckboxWrapper = (0, _styled["default"])('div')({
  width: '100%',
  height: '100%',
  marginTop: '-8px',
  'div[role=checkbox]': {
    label: {
      display: 'flex !important',
      padding: '0',
      backgroundColor: 'transparent',
      color: '#000000 !important',
      marginBottom: '0 !important'
    }
  },
  rect: {
    fill: '#ffffff'
  }
}, function (_ref) {
  var checkboxLabelColor = _ref.checkboxLabelColor;
  return {
    'div[role=checkbox]': {
      label: {
        backgroundColor: checkboxLabelColor ? checkboxLabelColor : 'transparent',
        padding: checkboxLabelColor ? '12px 16px' : '0'
      }
    }
  };
});

var Address = function Address(props) {
  var name = props.name,
      values = props.values,
      label = props.label,
      allowPO = props.allowPO,
      testId = props.testId,
      onSelect = props.onSelect,
      generateTemporaryToken = props.generateTemporaryToken,
      searchAddresses = props.searchAddresses,
      country = props.country,
      allowPropertyName = props.allowPropertyName,
      autoAddressError = props.autoAddressError,
      autoAddressErrorMessage = props.autoAddressErrorMessage,
      addressValidator = props.addressValidator,
      streetTypeOptions = props.streetTypeOptions,
      autoAddressPlaceholder = props.autoAddressPlaceholder,
      cantFindAddressLabel = props.cantFindAddressLabel,
      autoCompleteFieldColor = props.autoCompleteFieldColor,
      checkboxLabelColor = props.checkboxLabelColor;
  var cantFindAddressLabelText = cantFindAddressLabel !== null && cantFindAddressLabel !== void 0 ? cantFindAddressLabel : "Can't find your address";
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AutoAddress.AutoAddress, {
    label: label,
    name: "".concat(name, ".autoAddress"),
    values: values,
    allowPO: allowPO,
    testId: "".concat(testId, "-auto-address"),
    disabled: values.cantFindAutoAddress,
    selectedItem: values.autoAddress,
    helpText: allowPO ? '' : 'We do not accept PO Box addresses',
    onSelect: onSelect,
    generateTemporaryToken: generateTemporaryToken,
    searchAddresses: searchAddresses,
    country: country,
    autoAddressError: !values.cantFindAutoAddress ? autoAddressError : null,
    autoAddressErrorMessage: autoAddressErrorMessage,
    autoAddressPlaceholder: autoAddressPlaceholder,
    autoCompleteFieldColor: autoCompleteFieldColor
  }), /*#__PURE__*/_react["default"].createElement(TransparentCheckboxWrapper, {
    checkboxLabelColor: checkboxLabelColor
  }, /*#__PURE__*/_react["default"].createElement(_basis.Checkbox, {
    name: "".concat(name, ".cantFindAutoAddress"),
    optional: true,
    testId: "".concat(testId, "-cant-find-auto-address"),
    hideLabel: true,
    label: "",
    color: "transparent"
  }, cantFindAddressLabelText)), values.cantFindAutoAddress && /*#__PURE__*/_react["default"].createElement(_ManualAddress.ManualAddress, {
    name: name,
    values: values,
    allowPO: allowPO,
    testId: testId,
    country: country,
    allowPropertyName: allowPropertyName,
    addressValidator: addressValidator,
    streetTypeOptions: streetTypeOptions,
    cantFindAutoAddress: values.cantFindAutoAddress
  }));
};

var _default = Address;
exports["default"] = _default;